<template>
    <!-- Карточка элемента плейлиста — по образцу ddown.to (стили в _find.scss). Только отображение:
         состояние (element.inline, open), запрос форматов, GA и эксперимент — в MainResults.vue, сюда — события. -->
    <div class="playlist-card">
        <div class="playlist-card__preview">
            <img ref="image" :src="element.thumb" @error="onImageError" :alt="element.meta.title">
        </div>
        <div class="playlist-card__actions">
            <h6 class="playlist-card__title" :title="element.meta.title">{{ element.meta.title }}</h6>
            <p v-if="element.meta.duration" class="playlist-card__meta">Duration: {{ element.meta.duration }}</p>
            <p v-if="element.title" class="playlist-card__meta">{{ element.title }}</p>
            <p v-if="inline && inline.error" class="playlist-card__error">{{ inline.error }}</p>
            <!-- «Choose quality» — до загрузки форматов: во время запроса disabled со спиннером,
                 после ошибки остаётся и повторяет запрос -->
            <button v-if="inline && !inline.formats" type="button" class="playlist-btn" :id="'choose-quality-' + index"
                :disabled="inline.loading" :aria-busy="inline.loading ? 'true' : 'false'" @click="$emit('load')">
                <span v-if="inline.loading" class="playlist-btn__spinner" aria-hidden="true"></span>
                <span v-else>Choose quality</span>
            </button>
            <!-- после загрузки: выбор качества (выпадающий список) | Download выбранного формата -->
            <div v-else-if="inline" class="playlist-quality-group">
                <div class="playlist-quality" ref="quality" :class="{ 'is-open': open }">
                    <button type="button" class="playlist-quality__toggle" aria-haspopup="listbox"
                        :aria-expanded="open ? 'true' : 'false'" @click="$emit('toggle')">
                        <span class="playlist-quality__label"><format-label :format="selected" /></span>
                        <i class="fas fa-chevron-down playlist-quality__arrow" aria-hidden="true"></i>
                    </button>
                    <!-- v-show: список в DOM с момента загрузки — MainResults передаёт его tzPlatformLinks
                         (tzBestQuality, поле list) через ref list. Контейнеры .playlist-quality__extra Vue
                         не наполняет: строки эксперимента вставляются в них и не задеваются перерисовкой v-for -->
                    <div v-show="open" class="playlist-quality__list" role="listbox" ref="list">
                        <div class="playlist-quality__extra" @click="$emit('close')"></div>
                        <button type="button" v-for="(video, vi) in inline.formats" :key="video.url"
                            class="playlist-quality__option" role="option"
                            :class="{ 'is-selected': vi === inline.selected }"
                            :aria-selected="vi === inline.selected ? 'true' : 'false'" @click="$emit('select', vi)">
                            <format-label :format="video" />
                        </button>
                        <div class="playlist-quality__extra" @click="$emit('close')"></div>
                    </div>
                </div>
                <button type="button" class="playlist-btn playlist-btn--split" :id="downloadId"
                    @click="$emit('download', selected)">Download</button>
            </div>
            <button v-else type="button" class="playlist-btn" :id="downloadId" @click="$emit('download-direct')">Download</button>
        </div>
    </div>
</template>

<script>
import FormatLabel from './FormatLabel.vue';
import noImage from '../../img/placeholder/no-image.png';

// События: load — «Choose quality»; toggle — переключатель списка; close — клик по строке эксперимента;
// select(vi) — выбор формата; download(format) — Download выбранного; download-direct — Download прямой ссылки.
// ref quality — корень выпадающего списка (клик вне него закрывает список), ref list — сам список.
export default {
    name: 'PlaylistCard',
    components: { FormatLabel },
    props: {
        element: { type: Object, required: true },
        index: { type: Number, required: true },
        open: { type: Boolean, default: false },
    },
    computed: {
        inline() {
            return this.element.inline || null;
        },
        // выбранный формат (по умолчанию первый — лучшее видео со звуком); null до загрузки форматов
        selected() {
            const st = this.inline;
            if (!st || !st.formats) return null;
            return st.formats[st.selected] || st.formats[0];
        },
        // id кнопки Download для GA и экспериментов: у inline — выбранный формат с суффиксом -pl<index>,
        // у прямой ссылки — прежняя схема по полям элемента
        downloadId() {
            const f = this.selected || this.element;
            const id = 'download-' + f.ext + '-' + f.quality + '-' + (f.no_audio ? 'no-audio' : 'audio');
            return this.selected ? id + '-pl' + this.index : id;
        },
    },
    methods: {
        onImageError() {
            this.$refs.image.src = noImage;
        },
    },
};
</script>
